import React from 'react'

import ReactMarkdown from 'react-markdown'
import { Link } from 'react-router-dom'

import ArrowImage from '../../../../../assets/images/OP_Portal_Arrow_White_LT.svg'

const WhatsNewItem = ({ whatsNewItem }) => {
    const {
        fields: { title, body, publishedDate }
    } = whatsNewItem

    return (
        <div id="blog-post">
            <Link to="/whatsnew" className="back-link">
                <img src={ArrowImage} width="12" alt="back-button" /> back
            </Link>
            <h1>{title}</h1>
            <p className="blog-date">Last modified on {publishedDate}</p>

            <ReactMarkdown source={body} />
        </div>
    )
}

export default WhatsNewItem
